// extracted by mini-css-extract-plugin
export var bodySections = "_3t-8";
export var gray = "_3t-7";
export var green = "_3t-4";
export var iconContainer = "_3t-9";
export var iconWidgetContainer = "_3t-1";
export var phoneIcon = "_3t-2";
export var red = "_3t-5";
export var statusDot = "_3t-3";
export var widgetContainer = "_3t-0";
export var yellow = "_3t-6";